import React from "react";

const OnlinePayment = () => {
  return (
    <div class="container mt-4 text-justify lh-lg">
      <div class="row" style={{ padding: "5px" }}>
        <div class="col-md-12">
        <div className="overflow-hidden text-justify  my-2">
        <div className="title-text text-center">
          <h4>Online Payments</h4>
        </div> 
    
          <p>
            This online payment system is provided by JSA Medical College for Siddha and Research Centre. 
            JSA Medical College for Siddha and Research Centre may update
            these terms from time to time and any changes will be effective
            immediately on being set out here. Please ensure you are aware of
            the current terms. The country of domicile for JSA Medical College for Siddha and Research Centre is India.
          </p>
        </div>

        <div class="col-md-12">
          <h5 class="title-text text-center my-2">Terms & Conditions </h5>
          <p>
            Please read these terms carefully before using the online payment
            facility. Using the online payment facility on this website
            indicates that you accept these terms. If you do not accept these
            terms do not use this facility.{" "}
          </p>
        </div>

        <div class="col-md-12 ">
          <h6 class="title-text my-1" style={{ color: "#c8102e" }}>
            All payments are subject to the following conditions:-
          </h6>
          <p>
            The description of services of match making are specific to your
            need, when you log in with your unique password. Normally payment is
            required in advance (i.e. before you commence your activity).{" "}
          </p>
          <p>
            All Fees quoted are in Indian Rupees. The JSA Medical College for Siddha and Research Centre reserves the right to change the fees at any time.
          </p>
          <div>
            <ul>
              <li>
                {" "}
                Your payment will normally reach the JSA Medical College for Siddha and Research Centre account to which you are making a payment within
                two working days.{" "}
              </li>
              <li>
                {" "}
                We cannot accept liability for a payment not reaching the
                correct JSA Medical College for Siddha and Research Centre account due to
                you quoting an incorrect account number or incorrect personal
                details. Neither can we accept liability if payment is refused
                or declined by the credit/debit card supplier for any reason.{" "}
              </li>
              <li>
                {" "}
                If the card supplier declines payment the JSA College of
                Agriculture and Technology is under no obligation to bring this
                fact to your attention. You should check with your
                bank/credit/debit card supplier that payment has been deducted
                from your account.{" "}
              </li>
              <li>
                {" "}
                In no event will the JSA Medical College for Siddha and Research Centre
                be liable for any damages whatsoever arising out of the use,
                inability to use, or the results of use of this site, any
                websites linked to this site, or the materials or information
                contained at any or all such sites, whether based on warranty,
                contract, tort or any other legal theory and whether or not
                advised of the possibility of such damages.{" "}
              </li>
            </ul>
          </div>
        </div>

        <div class="col-md-12">
          <h5 class="title-text text-center my-1">Refund Policy </h5>
          <ul>
            <li>
              {" "}
              If the Customer leaves the JSA Medical College for Siddha and Research Centre before they complete their service period, there shall
              be no entitlement to a refund of paid service fees.{" "}
            </li>
            <li>
              {" "}
              Refunds, if applicable, at the discretion of the Management, will
              only be made to the debit/credit card used for the original
              transaction. For the avoidance of doubt nothing in this Policy
              shall require the JSA Medical College for Siddha and Research Centre to
              refund the Fees (or part thereof) unless such Fees (or part
              thereof) have previously been paid.{" "}
            </li>
          </ul>
        </div>
        <div class="col-md-12">
          <h5 class="title-text  text-center my-1">Privacy Policy </h5>
          <p>
            {" "}
            his Privacy Policy applies to all of the products, services and
            websites offered by JSA Medical College for Siddha and Research Centre.
            Sometimes, we may post product specific privacy notices or Help
            Centre materials to explain our products in more detail.{" "}
          </p>
          <p>
            If you have any questions about this Privacy Policy, please feel
            free to contact us through our website or write to us{" "}
          </p>
          <p>
            Information we collect and how we use it for our JSA Medical College for Siddha and Research Centre.
          </p>
        </div>
        <div class="col-md-12">
          <h5 class="title-text  text-center my-1">Changes to our Privacy Policy </h5>
          <p>
            {" "}
            JSA Medical College for Siddha and Research Centre reserves the entire right
            to modify/amend/remove this privacy statement anytime and without
            any reason. Nothing contained herein creates or is intended to
            create a contract/agreement between JSA Medical College for Siddha and Research Centreand any user visiting 
            the JSA Medical College for Siddha and Research Centre website or providing identifying information of any kind.
          </p>
        </div>

        <div class="col-md-12">
          <h5 class="title-text  text-center my-1">DND Policy </h5>
          <p>
                  If you wish to stop any further sms/email alerts/contacts from our
            side, all you need to do is send an email to{" "}
            <strong>svtrust.educ@gmail.com</strong> with your mobile numbers and
            you will be excluded from the alerts list.
          </p>
        </div>
        <div class="col-md-12">
          <h5 class="title-text  text-center my-1">Contact </h5>
          <p>
            Email :{" "}
            <a href="mailto:svtrust.educ@gmail.com"> svtrust.educ@gmail.com</a>
          </p>
          <p>
            <a
              href="https://jsacms.in/feespay/siddha/getinfo.php"
              class="btn btn-primary"
              role="button"
            >
              Online Fee Payment
            </a>
          </p>
        </div>
      </div>
    </div>
    </div>
  );
};

export default OnlinePayment;
